import { render, staticRenderFns } from "./incl-logChanges.vue?vue&type=template&id=1f28173e&scoped=true"
import script from "./incl-logChanges.vue?vue&type=script&lang=js"
export * from "./incl-logChanges.vue?vue&type=script&lang=js"
import style0 from "./incl-logChanges.vue?vue&type=style&index=0&id=1f28173e&prod&lang=css"
import style1 from "./incl-logChanges.vue?vue&type=style&index=1&id=1f28173e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28173e",
  null
  
)

export default component.exports